export default __webpack_public_path__ + "static/media/compra_ripley.6fa354de.svg";